import React from "react";

const LABEL_CLASS =
  "block font-display font-bold text-xs uppercase tracking-wider text-brand-muted mb-2";

export const FormField = ({ id, label, required, children }) => (
  <div>
    <label htmlFor={id} className={LABEL_CLASS}>
      {label}
      {required && " *"}
    </label>
    {children}
  </div>
);
